import { get } from '../../utils/PolyfillLodash'

// -------------------------------------------------
// INITIAL STATE
// -------------------------------------------------
export const initialState = {
  show: false,
  products: undefined
}

// -------------------------------------------------
// HELPERS
// -------------------------------------------------
const attributeKeyMaps = new Map([
  ['ProductName', 'name'],
  ['PromoText', 'specialOfferText']
])

export function getFreeDelivery(product) {
  return product.shipping === 0
}

export function normalizeProductAttributes(product) {
  const normalizedProductAttributes = {}

  attributeKeyMaps.forEach((key, value) => {
    normalizedProductAttributes[key] = product[value]
  })

  normalizedProductAttributes.featured = true
  normalizedProductAttributes.price = parseFloat(product.Price)
  normalizedProductAttributes.wasPrice = parseFloat(product.ComparePrice)
  normalizedProductAttributes.hasVariations = false
  normalizedProductAttributes.hasMultiplePrices = false
  normalizedProductAttributes.productLink = product.ProductPage
  normalizedProductAttributes.impBeacon = product.ImpBeacon
  normalizedProductAttributes.clickBeacon = product.ClickBeacon
  normalizedProductAttributes.freeDelivery = getFreeDelivery(product)
  normalizedProductAttributes.avgRating = parseFloat(product.avgRating)
  normalizedProductAttributes.reviewsCount = parseInt(product.reviewsCount)
  normalizedProductAttributes.deliverable = product.deliverable
  normalizedProductAttributes.detailAttributes = product.detailAttributes

  return normalizedProductAttributes
}

export function getProducts(payload) {
  const products = payload.SearchProductAd || payload.ProductAd
  if (products) {
    return products.map(product => {
      const normalizedProduct = {}
      normalizedProduct.id = product.ProductSKU
      normalizedProduct.attributes = normalizeProductAttributes(product)
      return normalizedProduct
    })
  }
}

function getProduct(store, productSku) {
  return store.products.find(product => product.id == productSku) // eslint-disable-line
}

export function getImpressionBeacon(store, productSku) {
  if (!store.products && !productSku) {
    return ''
  }

  const product = getProduct(store, productSku)

  if (get(product, 'attributes.beaconSent')) {
    return
  }

  return get(product, 'attributes.impBeacon')
}

export function getClickBeacon(store, productSku) {
  if (!store.products && !productSku) {
    return ''
  }

  const product = getProduct(store, productSku)

  return get(product, 'attributes.clickBeacon')
}
